import gql from "graphql-tag";

import { Submit } from "components/Button/Submit";
import { Form } from "components/Form/Form/Form";
import { FormInput } from "components/Form/Input/FormInput";
import { FormTextArea } from "components/Form/TextArea/FormTextArea";
import { Modal } from "components/Modal/Modal";
import { ServerKeyFragment, UpdateServerKey } from "generated/organizationuser";
import { useMutation } from "graphql-client/useMutation";
import { useTranslation } from "i18n";
import { notifier } from "utils/notifier";

gql`
  # schema = ORGANIZATION_USER
  mutation UpdateServerKey(
    $uuid: UUID!
    $serverKeyInput: UpdateServerKeyInput!
  ) {
    updateServerKey(uuid: $uuid, serverKeyInput: $serverKeyInput) {
      serverKey {
        ...ServerKey
      }
    }
  }
`;

type FormValues = {
  name: string;
  description: string;
};

export const ServerKeyComposer = ({
  serverKey,
  onClose,
}: {
  serverKey: ServerKeyFragment;
  onClose: () => void;
}) => {
  const t = useTranslation();
  const [updateServerKey] = useMutation(UpdateServerKey, {
    onSuccess: () => {
      notifier.success(
        t("developers.server_keys.server_key_composer.server_api_key_updated"),
      );
      onClose();
    },
  });

  return (
    <Modal
      title={t(
        "developers.server_keys.server_key_composer.edit_the_server_api_key",
      )}
      onHide={onClose}
      show
    >
      <Form<FormValues>
        className="flex-col w-full mt-24 space-y-24"
        initialValues={{
          name: serverKey.name ?? "",
          description: serverKey.description ?? "",
        }}
        onSubmit={({ name, description }) =>
          updateServerKey({
            uuid: serverKey.uuid,
            serverKeyInput: { name, description },
          })
        }
      >
        <FormInput
          name="name"
          label={t("developers.server_keys.server_key_composer.name")}
          placeholder={t("developers.server_keys.server_key_composer.name")}
          wrapperClassName="flex-fill"
        />
        <FormTextArea
          name="description"
          label={t("developers.server_keys.server_key_composer.description")}
          placeholder={t(
            "developers.server_keys.server_key_composer.description",
          )}
          wrapperClassName="flex-fill"
        />
        <Submit
          className="mt-36"
          label={t("developers.server_keys.server_key_composer.save")}
        />
      </Form>
    </Modal>
  );
};
